import styles from './StaffingTable.sass'

export enum ColumnId {
  Checkbox = 'Checkbox',
  Workspace = 'Workspace',
  OpportunityType = 'Opportunity Type',
  Location = 'Location',
  PrimarySoftware = 'PrimarySoftware',
  Backup = 'Backup',
  SupplementalSoftware = 'SupplementalSoftware',
  Specialties = 'Specialties',
  TypeOfWork = 'TypeOfWork',
  ProsRequired = 'ProsRequired',
  MaxApplicants = 'MaxApplicants',
  MaxConcurrentWorkspaces = 'MaxConcurrentWorkspaces',
  Applicants = 'Applicants',
  Status = 'Status',
  Action = 'Action',
}

export type SearchableStaffingSortField =
  | 'workspace_id'
  | 'location'
  | 'primary_software'
  | 'supplemental_software'
  | 'status'

export type StaffingColumnDetails = {
  id: ColumnId
  header: string
  align: 'left' | 'center' | 'right'
  select: boolean
  sortable: boolean
  styles: string
  field?: SearchableStaffingSortField
}

// TODO: If sortable is true, specify a field
export const StaffingTableColumns: StaffingColumnDetails[] = [
  {
    id: ColumnId.Checkbox,
    header: '',
    select: false,
    align: 'left',
    styles: styles.checkboxColumn,
    sortable: false,
  },
  {
    id: ColumnId.Workspace,
    header: 'Workspace',
    select: false,
    align: 'left',
    styles: styles.workspaceColumn,
    sortable: false,
  },
  {
    id: ColumnId.OpportunityType,
    header: 'Opportunity Type',
    select: false,
    align: 'left',
    styles: styles.opportunityTypeColumn,
    sortable: false,
  },
  {
    id: ColumnId.Location,
    header: 'Location',
    select: false,
    align: 'left',
    styles: styles.locationColumn,
    sortable: false,
  },
  {
    id: ColumnId.PrimarySoftware,
    header: 'Primary software',
    select: false,
    align: 'left',
    styles: styles.primarySoftwareColumn,
    sortable: false,
  },
  {
    id: ColumnId.Backup,
    header: 'Backup',
    select: false,
    align: 'center',
    styles: styles.backupColumn,
    sortable: false,
  },
  {
    id: ColumnId.SupplementalSoftware,
    header: 'Supplemental software',
    select: false,
    align: 'left',
    styles: styles.supplementalSoftwareColumn,
    sortable: false,
  },
  {
    id: ColumnId.Specialties,
    header: 'Specialties',
    select: false,
    align: 'left',
    styles: styles.specialtiesColumn,
    sortable: false,
  },
  {
    id: ColumnId.TypeOfWork,
    header: 'Type of work',
    select: false,
    align: 'left',
    styles: styles.typeOfWorkColumn,
    sortable: false,
  },
  {
    id: ColumnId.ProsRequired,
    header: 'Pros required',
    select: false,
    align: 'center',
    styles: styles.prosRequiredColumn,
    sortable: false,
  },
  // {
  //   id: ColumnId.MaxApplicants,
  //   header: 'Max applicants',
  //   select: false,
  //   align: 'center',
  //   styles: styles.maxApplicantsColumn,
  //   sortable: false,
  // },
  {
    id: ColumnId.MaxConcurrentWorkspaces,
    header: 'Max concurrent workspaces',
    select: false,
    align: 'center',
    styles: styles.maxConcurrentWorkspacesColumn,
    sortable: false,
  },
  // {
  //   id: ColumnId.Applicants,
  //   header: 'Applicants',
  //   select: false,
  //   align: 'center',
  //   styles: styles.applicantsColumn,
  //   sortable: false,
  // },
  {
    id: ColumnId.Status,
    header: 'Status',
    select: false,
    align: 'center',
    styles: styles.statusColumn,
    sortable: false,
  },
  {
    id: ColumnId.Action,
    header: '',
    select: false,
    align: 'right',
    styles: styles.actionColumn,
    sortable: false,
  },
]
